import type { Topic } from "@circle-react/types/Topic";

// Sorts topics to put admin_only topics first
export const sortTopics = (topics: Topic[]) =>
  [...topics].sort((a, b) => {
    if (a.admin_only && !b.admin_only) return -1;
    if (!a.admin_only && b.admin_only) return 1;
    return 0;
  });
